import request from '@/config/axios'

// 导出记录列表
export const export_list = (data: any): Promise<IResponse> => {
  return request.post({ url: '/admin/export/list', data })
}

export const export_updateComplateShow = (data: any = {}): Promise<IResponse> => {
  return request.post({ url: '/admin/export/updateComplateShow', data })
}

export const export_newComplateNum = (data: any = {}): Promise<IResponse> => {
  return request.post({ url: '/admin/export/newComplateNum', data })
}
